<template>
    <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
        <strong class="font-bold">{{ headline }}</strong>
        <span class="block sm:inline">{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: 'Alert',
    props: {
        text: String,
        headline: String
    }
}
</script>
